import { render, staticRenderFns } from "./AddSecret.vue?vue&type=template&id=6a56c77f&"
import script from "./AddSecret.vue?vue&type=script&lang=js&"
export * from "./AddSecret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports